/* eslint-disable import/prefer-default-export */
export const PULL_VOLTAGE_MONITOR_URL = 'http://10.10.10.30:5000/api/v1/loglist';
